import { Pagination } from '@mui/material';
import './CustomBottomPagination.css';

function CustomBottomPagination({
    current_page,               // The current active page
    total_page_count,           // Total number of pages
    on_change_value,            //  for page change
    on_page_count_update,       //  for items per page change
    items_per_page,             //FOR ITEMS PER CURRENT PAGE
    pagination                  //for start end and total entires 
}) {


    const ModifiedPagination = {
        "& .MuiPaginationItem-root": {
            borderColor: "#DFE3E8",
            backgroundColor: "#FFFFFF",
            color: "##4B5563",
            "&.Mui-selected": {
                borderColor: "#106262",
                backgroundColor: "#567C09",
                color: "#FFFFFF",
            },
            "&:hover": {
                borderColor: "#d9dbde",
                color: "#FFFFFF",
                backgroundColor: "#567C09",
            },
        },
    };

    return (
        <div className='custom_pagination_main_container'>
            {/* Items Per Page Section */}
            <div className='custom_pagination_sub_container_0'>
                <span className='custom_pagination_sub_text_0'>Items Per Page</span>
                <select
                    value={items_per_page}
                    className='custom_pagination_per_page_count'
                    onChange={(e) => {
                        on_page_count_update(e.target.value);
                        on_change_value(1); //For reset to first page when items per page changes OTHERWISE THIS LIST WILL NOT SHOWS DATA
                    }}
                >
                    {/* pageFrom is used to handle specific page limits for certain pages */}
                    <>
                        {/* <option value={10}>10</option> */}
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </>

                </select>
            </div>
            <div className='custom_pagination_sub_container_0'>
                {/* Pagination Controls */}
                <Pagination
                    count={total_page_count}
                    page={current_page}
                    variant="outlined"
                    shape="rounded"
                    sx={ModifiedPagination}
                    onChange={(event, value) => {
                        on_change_value(value);
                    }}
                />
                {/* Showing Range of Entries */}
                {/* <p className='custom_pagination_sub_text_0'>
                    Showing {pagination?.start} to {pagination?.end} of {pagination?.totalEntries} entries
                </p> */}
            </div>
        </div>
    );
}

export default CustomBottomPagination;
